<!-- 由 suu 创建于 2021-12-29  -->
<template>
  <div class="sel-poster" :class="{ 'sel-poster-get': showMask }" ref="box">
    <!-- 海报图 -->
    <div class="mask-container" v-if="showMask" @click="tap"></div>
    <div v-if="showPoster" class="poster-img animated zoomIn" @click="tap">
      <img :src="imgUrl" alt />
    </div>
    <div class="pos-btns" v-if="showPoster">
      <div class="pos-btn user-btn" @click="handelShare(1)">分享给朋友</div>
      <div class="pos-btn pos-btn-2 user-btn" @click="handelShare(2)">
        分享到朋友圈
      </div>
      <div class="pos-btn pos-btn-3 user-btn" @click="handelSaveImg">
        保存图片
      </div>
    </div>
    <!-- 背景 -->
    <!-- 生成完图片 保留底层渲染 加模糊 cp-cnet-filter -->
    <!-- 得到海报后 隐藏底层渲染 v-if="!showMask" -->
    <div class="cp-cnet" :class="{ 'cp-cnet-filter': showMask }">
      <img class="cp-bg" :src="bgImg" alt="" />
      <!-- 营养师名片 -->
      <img
        class="cp-bg-poster"
        v-if="curPerson"
        :src="curPerson.vote_img"
        alt=""
      />
      <!-- 二维码 -->
      <div class="qr-region" :class="{ 'qr-region-per': curPerson }">
        <canvas class="qr" id="qrCode-canvas"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas'
import QRCode from 'qrcode'

export default {
  name: 'sel-poster',

  components: {},

  props: {
    invitedCode: {}, // 邀请串
    curPerson: {} // 当前营养师
  },

  data() {
    return {
      imgUrl: '',
      showMask: false,
      showPoster: false
    }
  },

  computed: {
    // 背景图
    bgImg() {
      return this.curPerson
        ? 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/syr-poster-bg?v=1'
        : '	https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/syr-poster-bg-empty?v=1'
    },
    // 分享二维码链接
    qrcodeUrl() {
      return (
        'https://member3.gymcity.com.cn/#/app-download?invitedCode=' +
        this.invitedCode
      )
    }
  },

  watch: {},

  created() {},

  mounted() {
    setTimeout(() => {
      this.getImg()
    }, 200)
  },

  destroyed() {},

  methods: {
    handelShare(shareType) {
      this.$betterwe.onAppShare({
        shareType: shareType, //分享的类型 1 微信好友 2 微信朋友圈
        contentType: 'image', //分享的数据类型  image 分享图片  url 分享H5链接
        // 分享的数据
        shareData: {
          data: this.imgUrl, //分享的具体数据
          //分享的数据的格 式
          //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
          type: 'base64',
          desc: '快来打call领奖吧~',
          title: '为喜爱的营养师打call，领取100元优惠礼包！'
        }
      })
    },
    handelSaveImg() {
      this.$betterwe.onAppSaveImage({
        data: this.imgUrl, //分享的具体数据
        //分享的数据的格式
        //type=base64  表示图片格式是base64   type=url  表示图片格式是链接
        type: 'base64'
      })
    },
    // 点击已生成图片
    tap() {
      if (this.showMask) {
        this.$emit('close')
      }
    },
    /**
     * 生成海报
     */
    getImg() {
      const that = this
      console.log('that.$refs.box', this.qrcodeUrl)
      window.scrollTo(0, 0)
      this.$toast.loading('生成邀请图片中...')
      setTimeout(() => {
        this.$nextTick(() => {
          // 合成分享图
          let canvas = document.getElementById('qrCode-canvas')
          QRCode.toCanvas(canvas, that.qrcodeUrl, (error) => {
            if (error) {
              console.log(error)
            } else {
              html2canvas(that.$refs.box, {
                backgroundColor: null,
                useCORS: true
              })
                .then(function (canvas) {
                  that.$toast.clear()
                  that.imgUrl = canvas.toDataURL()
                  that.$emit('over', that.imgUrl)
                  window.scrollTo(0, 0)
                  that.$toast.clear()
                  that.showMask = true
                  setTimeout(() => {
                    that.showPoster = true
                    that.$toast('图片已生成，快分享给你的好友吧')
                  }, 100)
                })
                .catch((err) => {})
            }
          })
        })
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.sel-poster {
  width: 100vw;
  min-height: 100vh;
  // background-color: #fff;
  position: absolute;
  top: 10000px;
  // top: 0px;
  left: 0;
  z-index: 88;
  display: flex;
  flex-direction: column;
  align-items: center;
  .mask-container {
    background-color: #000;
    position: fixed;
    top: 0;
    left: 0;
    opacity: 0.6;
    width: 100%;
    height: 100%;
    z-index: 99;
  }
  .poster-img {
    width: 32%;
    position: absolute;
    top: 1%;
    // top: 50%;
    // left: 50%;
    // transform: translate(-50%, -50%);
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .pos-btns {
    width: 100vw;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 500px;
    .pos-btn {
      width: 85px;
      height: 28px;
      border-radius: 6px;
      box-sizing: border-box;
      font-size: 12px;
      background-color: #6ad195;
      color: #fff;
      font-weight: 600;
      display: flex;
      align-items: center;
      justify-content: center;

      z-index: 110;
      & + .pos-btn {
        margin-left: 10px;
      }
    }
    .pos-btn-2 {
      background-color: #2882e9;
    }
    .pos-btn-3 {
      background: linear-gradient(207deg, #f28a6c 0%, #ed629b 100%);
    }
  }
  .cp-cnet {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .cp-cnet-filter {
    filter: blur(15px);
  }
  .cp-bg {
    width: 100%;
    box-sizing: border-box;
  }
  .cp-bg-poster {
    width: 290px;
    position: absolute;
    left: 43px;
    top: 421px;
  }
  .qr-region {
    position: absolute;
    bottom: 145px;
    left: 98px;
    text-align: center;
    #qrCode-canvas {
      width: 177px !important;
      height: 177px !important;
    }
  }
  .qr-region-per {
    bottom: 154px;
  }
}
.sel-poster-get {
  top: 0;
}
</style>
